import { type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  type FetchingItemsState,
  createFetchingItemsSlice,
} from "features/Application/slices/createFetchingItemsSlice";
import { type CampaignSendOverview } from "../../types/state";
import { fetchOverviewSends } from "../thunks/campaignSendsOverviewThunk";

export interface CampaignSendsOverviewState extends FetchingItemsState<CampaignSendOverview> {
  selected: number[];
}

export const initialState: CampaignSendsOverviewState = {
  areAllLoaded: false,
  isLoading: false,
  items: [],
  itemsCount: 0,
  selected: [],
};

const campaignSendsOverviewSlice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.ThreatDefenceCampaigns,
    name: "sends",
  },
  reducers: {
    setSelected: (state, action: PayloadAction<number[]>) => {
      state.selected = action.payload;
    },
  },
  thunk: fetchOverviewSends,
});

export const { fetchBegin, fetchFailure, fetchSuccess, reset, setSelected } = campaignSendsOverviewSlice.actions;

export default campaignSendsOverviewSlice.reducer;
